<template>
  <div class="profile-dropdown-wrapper">
    <template v-if="isMobile">
      <ProfileMenuContent :options="options" :is-mobile="true" class="w-full" />
    </template>
    <VaDropdown v-else :offset="dropdownOffset" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <slot />
            <span class="ml-2">{{ userName }}</span>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent class="profile-dropdown__content md:w-60 px-0 py-4 w-full">
        <ProfileMenuContent :options="options" />
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useMsal } from '../../../../azure/useMsal'
import ProfileMenuContent from './ProfileMenuContent.vue'

const dropdownOffset: [number, number] = [9, 0]

const { accounts } = useMsal()

const userName = computed(() => {
  if (accounts.value.length > 0) {
    const name = accounts.value[0].name
    if (name) {
      return name.split(' ')[0]
    }
  }
  return 'N/A'
})

type ProfileListItem = {
  name: string
  to?: string
  href?: string
  icon: string
}

type ProfileOptions = {
  name: string
  separator: boolean
  list: ProfileListItem[]
}

withDefaults(
  defineProps<{
    options?: ProfileOptions[]
    isMobile?: boolean
  }>(),
  {
    isMobile: false,
    options: () => [
      {
        name: 'account',
        separator: true,
        list: [
          {
            name: 'profile',
            to: 'profile',
            icon: 'mso-account_circle',
          },
        ],
      },
      {
        name: 'preferences',
        separator: true,
        list: [],
      },
      {
        name: '',
        separator: false,
        list: [
          {
            name: 'logout',
            icon: 'mso-exit_to_app',
          },
        ],
      },
    ],
  },
)
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__anchor {
    display: inline-block;
  }
}
</style>
